(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/startclock/assets/javascripts/startclock.js') >= 0) return;  svs.modules.push('/components/sport/startclock/assets/javascripts/startclock.js'); 
'use strict';

var svs = svs || {};

(function(svs) {
  svs.sport = svs.sport || {};

  svs.sport.Startclock = function(el, html) {
    var containerEl = $(el);
    var interval;
    if (containerEl.length > 0) {
      containerEl.append(svs.sport.startclock.templates.startclock(html));

      setInterval(function() {
        var clockEl = containerEl.find('.count-down'),
          clone = clockEl.clone(),
          parent = containerEl.find('.count-down-clock-container');
        clockEl.remove();
        if (!clone.hasClass('has-run-once')) {
          clone.addClass('has-run-once');
        }
        parent.append(clone);
      }, 150000);
      interval = setInterval(function() {
        updateTime();
      }, 60000);
      updateTime();
    }

    function updateTime() {
      var now = moment(),
        second = now.seconds() * 6,
        minute = now.minutes() * 6 + second / 60,
        hour = ((now.hours() % 12) / 12) * 360 + minute / 12;
      containerEl.find('.hour').css('transform', 'rotate(' + hour + 'deg)');
      containerEl.find('.minute').css('transform', 'rotate(' + minute + 'deg)');
    }

    return {
      clear: function() {
        if (interval) {
          clearTimeout(interval);
          containerEl.empty();
        }
      }
    };
  };
})(svs);

 })(window);